const IMMEDIATE_PAYMENT_TERMS = /^(?:payment\s+)?due\s+(?:on|upon)\s+(?:receipt|submission)$/i;

export const normalizeInvoicePaymentTerms = (value) => {
	if (value === null || value === undefined) return '';
	if (typeof value === 'number' && Number.isFinite(value)) return value;
	const terms = String(value).trim();
	if (!terms) return '';
	return IMMEDIATE_PAYMENT_TERMS.test(terms) ? 'Due on receipt' : terms;
};

export const isInvoiceDueOnReceipt = (value) =>
	String(normalizeInvoicePaymentTerms(value)).toLowerCase() === 'due on receipt';
